import { IMPORT_MINDMAP_SUCCESS, IMPORT_MINDMAP_ERROR } from '../../actions/TodoManipulation/importMindmapAction';

const initialState = {
    data: [],
    isLoading: false,
    error: null,
};

const importReducer = (state = initialState, action) => {

    switch (action.type) {
        case IMPORT_MINDMAP_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload,
            };
        case IMPORT_MINDMAP_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default importReducer;